import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  FormLabel,
  HStack,
  Input,
  Stack,
  Text,
  VStack,
} from "@chakra-ui/react";
import MainInput from "../../../../components/Form/input";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { openQuestionsListModel } from "../../../../modules/admin-modules/models/Actions";

const StepTwo = ({
  watchTotalQustions,
  watchSubType,
  watchQuestionWay,
  data,
  setValue,
  register,
  errors,
  isFormOne,
  watchChapters,
  isAdd,
  watchType,
}) => {
  const dispatch = useDispatch();
  const colourStyles = {
    control: (styles) => ({
      ...styles,
      width: "100%",
      background: "#f5f5f5",
      color: "#690000",
      borderRadius: "16px",
    }),
    option: (styles) => ({ ...styles, color: "#690000" }),
  };

  const [fieldsCount, setFieldsCount] = useState(1);

  const chapters = useSelector((state) => state.chapters.chapters);
  const groups = useSelector((state) => state.groups.groups);
  const performanceGroups = useSelector(
    (state) => state.groups.performanceGroups
  );

  const groupsOptions = groups?.map((data) => {
    return { value: data.id, label: data.name };
  });

  const performanceGroupsOptions =
    performanceGroups?.length > 0
      ? performanceGroups?.map((data) => {
          return { value: data.id, label: data.name };
        })
      : [];

  const activeChaptersOptions = chapters
    ?.filter((data) => Number(data.active) === 1)
    ?.map((data) => {
      return { value: data.id, label: data.name };
    });
  const inactiveChaptersOptions = chapters
    ?.filter((data) => Number(data.active) === 0)
    ?.map((data) => {
      return { value: data.id, label: data.name };
    });

  useEffect(() => {
    setValue("sub_type", 2);
    setValue("chapters[1][no_of_questions]", 0);
  }, [setValue]);

  const totalSelectedQuestions = watchChapters?.reduce((accumulator, value) => {
    return Number(accumulator) + Number(value?.no_of_questions || 0);
  }, 0);
  return (
    <VStack
      display={!isFormOne ? "flex" : "none"}
      dir="rtl"
      w="100%"
      flexWrap="wrap"
      justifyContent="space-between"
      spacing="50px"
    >
      <HStack w="100%" gap={5} mt={4}>
        <Box w="45%">
          <FormLabel>المجموعات : </FormLabel>
          <Select
            options={groupsOptions}
            isMulti={true}
            onChange={(data) => {
              const selectedGroups = data.map((val) => val.value);
              setValue("groups", selectedGroups);
            }}
            styles={colourStyles}
            placeholder="المجموعات"
            defaultValue={data?.groups?.map((val) => {
              return { label: val?.name, value: val?.id };
            })}
          />
        </Box>
        <Box w="45%">
          {performanceGroupsOptions?.map((data, index) => {
            return (
              <>
                <FormLabel>{data?.label}</FormLabel>
                <MainInput
                  label=""
                  defaultValues={data.question_number}
                  error={errors?.question_number?.message}
                  placeholder=" ادخل عدد الدرجات "
                  register={register}
                  name="question_number"
                  required={false}
                  onChange={(e) => {
                    setValue(
                      `chapters[${index + 1}][min_target]`,
                      e?.target?.value
                    );
                    setValue(
                      `chapters[${index + 1}][performance_gp_id]`,
                      data?.id
                    );
                  }}
                />
              </>
            );
          })}
        </Box>
      </HStack>
      <Box w="100%">
        <FormLabel> طريقة السؤال : </FormLabel>

        <Stack
          direction="row"
          role="group"
          aria-labelledby="my-radio-group"
          spacing="30px"
        >
          <label>
            <input
              {...register("random", { required: "هذه المعلومات مطلوبة" })}
              type="radio"
              value="0"
              defaultChecked={data?.random == 0 ? true : false}
            />
            أسئلة يختارها المدرس
          </label>
          <label>
            <input
              {...register("random", { required: "هذه المعلومات مطلوبة" })}
              type="radio"
              value="1"
              defaultChecked={data?.random == 1 ? true : false}
            />
            اسئلة عشوائية من بنك الاسئلة
          </label>
          <Text color="red">{errors?.random?.message}</Text>
        </Stack>
      </Box>
      <HStack w="100%" alignItems="flex-start">
        <Box w="50%">
          <FormLabel w="30%">عدد الأسئلة : </FormLabel>
          <MainInput
            label=""
            defaultValues={data.question_number}
            error={errors?.question_number?.message}
            placeholder=" ادخل عدد الأسئلة "
            register={register}
            name="question_number"
            required={false}
          />
        </Box>
        {!isAdd && watchQuestionWay == 0 && (
          <Button w="30%" onClick={() => dispatch(openQuestionsListModel())}>
            أخترالاسئلة
          </Button>
        )}
      </HStack>

      {watchTotalQustions && (
        <HStack w="100%" alignItems="flex-start">
          <VStack w="70%" alignItems="flex-start">
            <FormLabel>الفصول : </FormLabel>

            <Box w="45%">
              <Select
                options={activeChaptersOptions}
                isMulti={false}
                onChange={(selected) => {
                  setValue("chapters[1][chapter_id]", selected?.value);
                  setValue("chapters[1][no_of_questions]", 0);
                }}
                styles={colourStyles}
                placeholder="الفصل"
                defaultValue={
                  data?.chapters?.[0]
                    ? {
                        label: data?.chapters?.[0]?.name,
                        value: data?.chapters?.[0]?.id,
                      }
                    : null
                }
              />
            </Box>

            {[...Array(fieldsCount)].map((val, index) => {
              return (
                <HStack w="100%" spacing="40px" key={index}>
                  <Box w="45%">
                    <Select
                      options={inactiveChaptersOptions}
                      isMulti={false}
                      onChange={(data) => {
                        setValue(
                          `chapters[${index + 2}][chapter_id]`,
                          data?.value
                        );
                      }}
                      styles={colourStyles}
                      placeholder="حافظة الاسئلة"
                      defaultValue={
                        data?.chapters?.[index + 1]
                          ? {
                              label: data?.chapters?.[index + 1]?.name,
                              value: data?.chapters?.[index + 1]?.id,
                            }
                          : null
                      }
                    />
                  </Box>

                  <HStack w="45%">
                    <FormLabel w="60%">عدد الأسئلة : </FormLabel>
                    <Input
                      size="md"
                      defaultValue={
                        data?.chapters?.[index + 1]?.no_of_questions
                      }
                      error={errors?.question_number?.message}
                      onChange={(e) => {
                        setValue(
                          `chapters[${index + 2}][no_of_questions]`,
                          e.target.value
                        );
                      }}
                      placeholder="   اكتب عدد الاسئلة "
                      name="question_number"
                    />
                  </HStack>
                </HStack>
              );
            })}
          </VStack>
          <Button
            w="30%"
            onClick={() => setFieldsCount((s) => s + 1)}
            isDisabled={
              totalSelectedQuestions >= watchTotalQustions ? true : false
            }
          >
            أضف فرعا آخر
          </Button>
        </HStack>
      )}
    </VStack>
  );
};

export default StepTwo;
